"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = initOffcanvasMenu;
function initOffcanvasMenu() {
    var burgerMenu = document.getElementById("burger-menu");
    var offcanvasMenu = document.getElementById("offcanvas-menu");
    var closeMenuButton = document.getElementById("close-menu");
    if (!burgerMenu || !offcanvasMenu || !closeMenuButton) {
        console.warn("One or more Offcanvas menu elements are missing in the DOM.");
        return;
    }
    // Offcanvas-Menü öffnen
    burgerMenu.addEventListener("click", function () {
        offcanvasMenu.classList.remove("-translate-x-full");
    });
    // Offcanvas-Menü schließen
    closeMenuButton.addEventListener("click", function () {
        offcanvasMenu.classList.add("-translate-x-full");
    });
}
